import { useEffect, useState } from 'react';
import companySettingsService from '../services/companySettingsService.js';
import { companyRequiresPaidSettlementBeforeMl } from '../utils/mlPaidSettlementRules.js';

/**
 * Live company flag for blocking unremitted Paid GCs on dispatch.
 * Session user can be stale after admin saves Company Settings — always refresh once.
 */
export function useRequirePaidSettlementBeforeMl(user) {
  const [required, setRequired] = useState(() => companyRequiresPaidSettlementBeforeMl(user));

  useEffect(() => {
    setRequired(companyRequiresPaidSettlementBeforeMl(user));
  }, [user?.require_paid_settlement_before_ml]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await companySettingsService.getSettings();
        if (!cancelled) {
          setRequired(res?.data?.require_paid_settlement_before_ml !== false);
        }
      } catch {
        // Keep session default when settings cannot be loaded.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return required;
}
